<template>
  <el-dialog
    title="功能使用协议"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="createOrderPrivacy">
      <div style="max-height:400px;overflow-y: auto;">
        <div class="title">国内快递服务协议</div>
        <div class="sub-title-line">欢迎寄件用户（以下称 “您” 或 “寄件人”）与圆通速递有限公司（以下简称 “圆通”）及圆通特许其经营的加盟公司（以下简称 “圆通加盟网点”）签署本协议。</div>
        <div class="sub-title-line">【审慎阅读】</div>
        <div class="sub-title-line">您在点击同意本协议之前，应当认真阅读并充分理解各条款内容，特别是免除或者限制圆通责任的条款、法律适用和争议解决条款。如有任何疑问，可向圆通客服咨询，然后决定是否使用圆通的快递服务。</div>
        <div class="sub-title-line">【签约动作】</div>
        <div class="sub-title-line">当您按页面上的提示填写信息、勾选 “我已阅读并同意服务协议”、点击 “下单”，即表示您已充分阅读、理解并接受本协议的全部内容。阅读及填写的过程中，如果您不同意本协议或其中任何条款，您应立即停止使用圆通的快递服务。</div>
        
        
        <div class="content">
          <div class="title">一、快递员上门寄件服务与圆通加盟网点寄件服务</div>
          <dt class="cont">您选择快递员上门寄件并填写寄件信息，点击 “下单” 后，圆通将为您匹配圆通加盟网点，并向您展示圆通加盟网点指派并回传的寄件服务人员信息。被指派的寄件服务人员将按照寄件订单信息中约定的预约上门时间到达您指定的寄件地址，进行物品揽收、寄递费用核算、回传运单号和物流信息，并将您委托寄递的物品配送至收件地址。</dt>
          <dt class="cont">您也可以选择到圆通加盟网点的营业场所办理寄件业务。快递员上门寄件服务与圆通加盟网点寄件服务均以本协议为依据为您提供快递服务。圆通特许经营的加盟网点是为您提供快递服务的法律主体。</dt>
          
          <div class="title">二、圆通为您提供的服务</div>
          <dt class="cont">圆通通过寄件服务平台为您提供技术服务。您可以使用寄件平台填写寄件订单信息、选择期望的上门时间、对寄递物品在线保价、在线预估运费、发送订单信息，圆通加盟网点承接并确认揽收您发送的订单信息后，您可以在线支付运费、对圆通加盟网点的服务人员进行评价等。为持续改善用户体验，您同意，圆通有权对圆通寄件服务平台的产品和服务不定期调整，具体以圆通寄件服务平台显示的内容为准。</dt>
          <dt class="cont">您同意：您授权圆通以技术手段为您匹配可为您提供快递员上门寄件服务的圆通加盟网点，匹配成功后，寄递 / 运输的法律关系由您与圆通加盟网点建立。如您希望知晓具体的圆通加盟网点的名称等情况，您可通过致电圆通客服咨询。</dt>
          <dt class="cont">您同意：圆通并不保证在您期望的上门时间内一定会有圆通加盟网点的服务人员承接并处理您的寄件订单。</dt>
          <dt class="cont">您应谨慎注意并明确知晓，您向快递员交付托寄物品后，关于寄递服务的具体权利义务，除圆通与您之间另有约定外，以您与圆通加盟网点及其服务人员之间的书面约定为准。您与圆通加盟网点发生纠纷需要圆通提供客服协助的，圆通可介入协调处理，但圆通不对圆通加盟网点为您提供的服务承担任何担保和保证责任。</dt>
          <dt class="cont">托寄物品交付并完成费用支付后，如果您选择寄件后在线开具电子发票的，相关的开票主体为圆通，圆通将通过加盟网点指定其快递员为您提供上门寄件服务。</dt>

          <div class="title">三、您使用快递员上门服务或在圆通加盟网点的经营场所办理寄件应遵守的交易规则</div>
          
          <dt class="cont">1. 您使用圆通快递员上门寄件服务平台下单或在圆通加盟网点的经营场所办理寄件时，应仔细填写寄件信息（包括寄件人、寄件人联系方式、寄件地址、收件人、收件人联系方式、收件地址、期待上门取件时间、物品类型、保价等信息），并保证上述您填写信息的准确性、有效性、完整性。如因您填写的寄件信息不准确、无效或不完整，导致您下达的订单无法顺利履行（包括无法按时上门揽收、揽收后无法派送等）或发生快件丢失、毁损、延误时无法证明物品种类、数量、价值等，您应自行承担全部责任。</dt>
          <dt class="cont"><span class="y-fc-F32F52">特别提示：您在圆通加盟网点的经营场所办理寄件时，快件运单上的上述寄件信息及对《国内快递服务协议》的同意均视为您本人提交，无论您是否曾向经营场所的服务人员咨询或寻求过协助、指导。</span></dt>
          <dt class="cont">2. 您通过寄件平台发送订单后，您应在圆通加盟网点指派的服务人员到达您指定的寄件地址前，妥善整理好您需要寄递的物品，并准备好您在下单页面填写的寄件人的有效身份证件，配合服务人员依法验视寄递物品和寄件人身份证件。圆通加盟网点对您的身份信息和寄递信息承担保密义务。</dt>
          <dt class="cont">3. 圆通加盟网点指定的服务人员上门后，您将寄递物品交付服务人员验视前，应通过取件码或圆通客服、圆通页面提示的人员信息等核验服务人员的身份，以确保将物品交付给圆通寄件服务平台的线上订单对应的服务人员，避免不必要的损失。如核验不一致的，您有权拒绝向服务人员交付寄递物品，否则由此造成的损失由您本人承担。寄件人应本着节约、绿色环保的原则，对所寄物品进行妥善包装，合理使用包装材料和包装方式，避免过度包装和随意包装，同时应确保快件包装符合快递运输的安全要求，保证快件在运输途中不会发生破损、变形、渗漏。如因您的包装方式不当导致物品在运输中发生破损、变形、渗漏等情形而造成您或他人的经济损失，您将承担全部责任。</dt>
          <dt class="cont">4. 实名认证：圆通加盟网点指派的服务人员按照国家相关法律法规规定需采集寄件人的实名信息，采集信息的方式包括扫码实名和证件实名方式。</dt>
          <dt class="cont">（1）扫码实名：寄件人可以使用支付宝实名码、阿里实人通行证（具体指天猫、手淘、闲鱼的实人通行证功能）向圆通加盟网点指派的服务人员提供个人实名信息，前述服务人员使用包裹侠 APP 或嵌入包裹侠 SDK 的圆通加盟网点的自有 APP 的扫描功能即可成功采集您的个人信息。</dt>
          <dt class="cont">（2）证件实名：圆通加盟网点指派的服务人员可手动输入寄件人的有效证件信息，可提交的有效证件种类包括您的身份证、临时身份证、户口簿、军人身份证、警察身份证、驾照、港澳台通行证、护照；或者服务人员可通过拍照录入您的身份证件照片，使用技术手段识别您的证件信息。</dt>
          <dt class="cont">（3）您同意，您将积极配合服务人员采集您的实名信息，录入圆通系统，由圆通提供给圆通加盟网点后，由圆通加盟网点最终提交国家邮政管理机关进行登记备案。您承诺，您向服务人员提交的上述信息具有真实性、有效性、完整性，并且与您的订单信息中的寄件人信息保持一致。如果您不配合服务人员进行实名认证的，服务人员有权拒绝向您提供寄递服务；如果您提供的寄递实名信息虚假或无效，或者与订单的寄件人信息不一致的，由此导致的责任均由您本人承担。</dt>
          <dt class="cont">（4）为了您与圆通加盟网点按照国家相关法律法规规定进行实名认证，同时为了便利操作，您同意：在您配合圆通加盟网点指派的服务人员采集实名信息、完成实名认证、录入圆通系统后，当您再次使用快递员上门服务时，在满足同一圆通加盟网点、同一服务人员为您提供服务的前提下，圆通系统将最近一次采集的实名信息预先显示在圆通系统中（实名信息均为脱敏显示）供该服务人员进行实名认证，该服务人员应当当场对预先显示的实名信息进行核验。如果该服务人员经过现场核验不一致的，则您应当积极配合该服务人员采集正确的实名信息。您有权致电客服电话，要求删除圆通系统中预录入的实名信息。</dt>
          <dt class="cont">5. 您应遵守国家相关法律法规规定及附件《禁限物品及贵重物品寄递告知》，不得寄递国家禁止寄递的物品，否则圆通加盟网点指派的服务人员有权拒绝履行您的订单，并有权将您违规禁寄物品的情况依法报告给主管机关，由此导致的责任（包括但不限于行政责任、刑事责任）均由您本人承担。除国家禁止寄递的物品外，圆通加盟网点有权根据自身的履约能力判断是否承运依照法律法规规定限制寄递的物品，具体以圆通加盟网点验视后决定是否确认揽收为准，圆通加盟网点对其揽收物品的范围向您负责。</dt>
          <dt class="cont">6. 您承诺，您应保证在线下单时填写的订单信息（尤其是寄件人、寄件人联系方式、寄件地址）与电子面单或纸质面单保持一致，并在交付物品前向快递公司索要寄件面单纸质版，以备留存。如因您的原因造成线上订单信息与线下面单信息不一致，或发生纠纷或投诉时您无法证明您物品交付时服务人员提供的运单号或相应运单凭据，导致您无法就寄递服务的履行向圆通或圆通加盟网点主张权利的，圆通对此不承担任何责任。</dt>
          <dt class="cont">7. 费用</dt>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（1）运费充值：</span>使用圆通客户管家寄件服务活动前，请根据每日预估发货量核算寄件运费，提前为用户账户钱包预充值一定金额运费；完成充值后，可使用圆通客户管家寄件服务下单寄件，无需额外进行圆通客户编码的绑定或单号余额充值。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（2）下单金额校验：</span>下单校验用户应保持钱包内运费余额充足（确保金额满足系统按最低单量梯队计算的预估运费金额），若余额不足将导致扣费失败，将无法继续使用圆通客户管家寄件服务服务；针对未结算包裹，圆通速递有权拦截并按原路退回，包裹一旦发出，已产生的运费不予退还。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（3）运费冻结：</span>下单后，系统将按最低单量梯队冻结相应金额；冻结期间相应的运费无法提现或使用，待运费结算完成，冻结金额将自动释放，您可再次用于下单或提现。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（4）运费冻结返还：</span>若用户在使用圆通客户管家寄件服务服务下单后在实际揽收前取消订单，相应冻结的运费金额将解冻释放。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（5）运费结算：</span>以自然日为周期，当天 24 点前取件的订单计入当日有效单量，下单后需及时联系业务员发货。包裹重量以圆通推送的结算重量为最终，体积重与实际称重取最大值（体积重计算公式：长×宽×高（cm）÷8000）；运单完成签收（以正常签收为准）的次日起，系统根据结算重量计算实际运费，并从预充值账户中扣除；无签收记录的运单不予结算。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（6）自动退费：</span>用户订单自生成之日起15日内无取件及之后轨迹，或取件（揽收）后无其他轨迹，圆通有权自动发起拦截取消订单并退费；拦截扫描、始发端退回不计入操作轨迹。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（7）拦截更址计费：</span>订单地址发生变更的，无首中心操作记录的，按最新地址结算并多退少补；有首中心操作记录的，按最新地址结算，少补但多不退。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（8）发票开具：</span>预充值运费若未产生实际寄件扣费，暂无法开具发票；待实际扣除运费后，可针对已扣金额申请开具对应发票。</div>
          <div class="title sub-title mt10"><span class="y-f-b y-fc-000">（9）价格说明：</span>下单页面展示预估价格为参考价，实际扣费以结算账单为准；部分订单可能存在扣款延迟，具体扣款时间与金额以账单记录为准。</div>
          <dt class="cont">8. 技术服务费：圆通暂时不向您就技术服务收取技术服务费，但圆通保留向您收取技术服务费的权利。您认可，圆通有权依据市场经营情况和公司的运营政策向您收取技术服务费。</dt>
          <dt class="cont">9. 关于赔偿的约定</dt>
          <dt class="cont">您通过寄递服务平台下达订单或在圆通加盟网点的经营场所办理寄件，且订单信息与实际交寄的文件、物品相符的情况下，您与圆通加盟网点一致同意按下述条款处理有关快件毁损、丢失的理赔事项：</dt>
          <div class="title sub-title">重要提示：在任何情况下，寄件人交寄单票快件的价值<span class="y-fc-F32F52">文件类不得超过 2000 元</span>，物品类不得超过 30000 元，超过此限额的，应分拆寄递。因文件、物品的性质不能分拆的，圆通加盟网点将不予收寄，已错误收寄或寄件人未声明价值而被收寄，若发生破损、短少、丢失的，寄件人无权向圆通及圆通加盟网点提出超过文件类 2000 元、物品类 30000 元的索赔主张。<span class="y-fc-F32F52">赔偿范围仅限于文件、物品的本身所具有的客观现实价值，不包括其可能获得的收益、利润、实际用途、商业机会、商业价值、文件或物品的精神价值、纪念价值以及文件、物品因丢失、短少、毁损、延误可能导致违约等间接损失。赔偿标准以寄件人是否选择保价并支付保价费区分为未保价快件和保价快件。是否保价由寄件人自愿选择，贵重快件建议选择保价，价值在人民币 1000 元（含）以内，保价费为 1 元；价值人民币 1000 元至 2000 元（含），保价费为 2 元；价值在人民币 2000 元至 1 万元（含），保价费为保价金额的 3‰；价值在人民币 1 万元至 3 万元（含），保价费为保价金额的 5‰。文件类最高保价金额为 2000 元，物品类最高保价金额为 30000 元。未选择保价的快件一律视为普通快件，按约定的未保价快件限额赔偿。</span></div>
          <dt class="cont"><span class="y-fc-F32F52">快件的赔偿规则如下：</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">（1）快件破损、毁损：</span>是指圆通加盟网点未能按照约定为您寄递的物品提供妥善的存储、运输、保管，致使快件外包装破损而导致快件内的文件、物品破损。若文件、物品仅外包装破损但文件、物品本身完好的，圆通加盟网点不负责赔付。</dt>
          <dt class="cont"><span class="y-fc-F32F52">未保价的普通快件破损、毁损赔付规则：</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">文件、物品破损但不影响主要功能，若您可提供有效货值证明，圆通加盟网点按照有效货值的 20% 赔偿，文件类最高赔偿 100 元，物品类最高赔偿 300 元；若您不能提供有效货值证明，圆通加盟网点按最多 10 倍运费赔偿，文件类最高赔偿 100 元，物品类最高赔偿 300 元。</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">保价的快件破损、毁损赔付规则：</span></dt>          
          <dt class="cont">保价快件发生破损、毁损的，按实际损失价值赔偿，但最高不超过快件的保价金额。</dt>
          <dt class="cont">（2）快件丢失、短少：是指圆通加盟网点未按约定为您寄递的物品提供妥善的存储、保管，致使物品出现丢失，包括物品短少、物品整体丢失。下述情形视为丢失：(A) 有第一条物流信息后的任一节点停滞 4 天无信息更新；(B) 在物流应签收时效 + 7 天后仍未有签收信息。</dt>
          <dt class="cont"><span class="y-fc-F32F52">未保价的快件，发生丢失、短少的，文件类最高赔偿 100 元，物品类最高赔偿不超过 300 元 / 票。</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">保价快件发生丢失的，按实际损失价值赔偿，但最高不超过快件的保价金额。保价快件短少的，按短少数量所占的比例赔偿。</span></dt>
          <dt class="cont"><span class="y-f-b y-fc-000">（3）不保价的货物种类：</span></dt>
          <dt class="cont indent">A. 邮政、航空等各相关法律法规禁寄品；</dt>
          <dt class="cont indent">B. 中国大陆境内无修复或定损技术能力的精密货品；</dt>
          <dt class="cont indent">C. 易碎品：玻璃类、陶瓷类、石膏类，石材类，大型雕刻类以及不易妥善包装的物品；<span class="y-f-b y-fc-000">3C 类中含易碎屏幕（超过 15.6 寸）的产品；</span></dt>
          <dt class="cont indent">D. 无法核实其真实价值的货物（如：文物、古董、有纪念意义的个人物品、二手物品、有价证券、重要文件、证件、发票、票据等）。</dt>
          <dt class="cont">（4）有效货值证明：如无特别约定，您提供的购置发票、付款凭证等，经圆通确认后，可视为有效货值证明。</dt>
          <dt class="cont">（5）您可直接拨打圆通加盟网点的客诉电话或圆通官方客服电话进行投诉，若投诉成立的，圆通加盟网点将直接按照赔付规则向您赔付。您同意，若您同意圆通介入处理您与圆通加盟网点的服务纠纷，您认可圆通具有最终判责权。</dt>
          <dt class="cont"><span class="y-fc-F32F52">10. 签收</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">您同意并应促使收件人同意圆通或其加盟网点可以根据实际情况，按照如下方式之一，安全、合理地投递快件：</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">（1）交由收件人本人签收；</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">（2）交由收件人的同住人或指定的代收人签收；</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">（3）投递至收件地址范围内的智能快件箱或快递服务站；</span></dt>
          <dt class="cont"><span class="y-fc-F32F52">（4）您或收件人指定的其他方式。</span></dt>
          <dt class="cont">11. 圆通严格禁止您或伙同第三方以欺诈或其他非正常使用服务（如利用圆通的系统漏洞）的方式获取圆通快递员上门寄件服务平台给予的各种补贴、扶持政策、商业利益。您参加圆通快递员上门寄件服务平台获得的任何补贴、扶持政策和商业利益，均以圆通的相关公告和活动规则的规定为准，否则，圆通有权没收您的违法或违规所得，注销您的账号使用资格，并追究您及第三方行为人的法律责任。</dt>
          <dt class="cont">12. 您同意，您违反本协议承诺、约定或违反法律法规规定时，圆通有权做出相应处理，包括但不限于屏蔽、删除您发布的订单信息，暂停或终止向您提供服务，且无须事先征得您的同意或提前通知您，并有权要求您承担相应的责任（包括但不限于民事、刑事责任）。</dt>
          
          <div class="title"><span class="y-fc-F32F52">四、圆通的责任承担和免除</span></div>

          <dt class="cont">1. 您了解并同意，圆通不对因下述情况而导致您的任何损害赔偿承担责任，包括但不限于利润、名誉、商誉、使用用途、数据等方面的损失或其它无形损失的损害赔偿：</dt>
          <dt class="cont indent">A. 因不可抗力、政府行为、司法行政命令等不可预见、不可避免、不可克服的客观情况导致的；</dt>
          <dt class="cont indent">B. 因您自身原因或您与圆通加盟网点或服务人员之间的纠纷导致的；</dt>
          <dt class="cont indent">C. 因寄递物品本身的自然性质、质量瑕疵等原因导致的；</dt>
          <dt class="cont indent">D. 法律法规规定的其他圆通不承担责任的情形。</dt>
          <dt class="cont">2. 如因不可抗力或其他圆通无法控制的原因使圆通服务平台崩溃或无法正常使用导致服务无法完成或丢失有关的信息、记录等，圆通不承担责任。但是圆通会尽可能合理地处理善后事宜，并努力使客户免受或减少经济损失。</dt>

          <div class="title">五、其他约定</div>
          <dt class="cont">1. 本协议内容包括本协议正文及所有圆通已经发布的或将来可能发布的各类规则，所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。圆通有权根据国家法律法规，对产品和服务规则进行修改，本协议或各类规则将以客户管家系统公示的方式进行公示。如您继续使用圆通提供的服务的，即表示您接受修订的协议和规则。</dt>
          <dt class="cont"><span class="y-fc-F32F52">2. 本协议的订立、履行、解释及争议的解决均应适用中国法律。如双方就本条款内容或其履行发生任何争议，双方应尽力友好协商解决；协商不成，任何一方应向圆通速递有限公司注册地的人民法院提起诉讼。</span></dt>
          <dt class="cont"><span class="y-f-b y-fc-000">3. 服务价格调整：</span>因市场、成本、政策发生变化，圆通可调整寄递服务运价，调价将提前 7 个自然日通过平台公告及站内信通知用户。调价生效前已下单订单按原价格执行。用户不接受调价的，可停止使用服务并按协议规则申请提现剩余余额；继续下单使用即视为认可新价格。</dt>
          <dt class="cont">附：《禁限物品及贵重物品寄递告知》</dt>
          <dt class="cont">一、贵重物品寄递说明</dt>
          <dt class="cont">为了更好的保障您的权益，寄递贵重物品时，建议您向圆通加盟网点购买保价服务，以便在货物发生丢失、短少、毁损时获得更好的保障。</dt>
          <dt class="cont">1. 枪支（含仿制品、主要零部件）弹药</dt>
          <dt class="cont">（1）枪支（含仿制品、主要零部件）：如手枪、步枪、冲锋枪、防暴枪、气枪、猎枪、运动枪、麻醉注射枪、钢珠枪、催泪枪等。</dt>
          <dt class="cont">（2）弹药（含仿制品）：如子弹、炸弹、手榴弹、火箭弹、照明弹、燃烧弹、烟幕（雾）弹、信号弹、催泪弹、毒气弹、地雷、手雷、炮弹、火药等。</dt>
          <dt class="cont">2. 管制器具</dt>
          <dt class="cont">（1）管制刀具：如匕首、三棱刮刀、带有自锁装置的弹簧刀（跳刀）、其他相类似的单刃、双刃、三棱尖刀等。</dt>
          <dt class="cont">（2）其他：如弩、催泪器、催泪枪、电击器等。</dt>
          <dt class="cont">3. 爆炸物品</dt>
          <dt class="cont">（1）爆破器材：如炸药、雷管、导火索、导爆索、爆破剂等。</dt>
          <dt class="cont">（2）烟花爆竹：如烟花、鞭炮、摔炮、拉炮、砸炮、彩药弹等烟花爆竹及黑火药、烟火药、发令纸、引火线等。</dt>
          <dt class="cont">（3）其他：如推进剂、发射药、硝化棉、电点火头等。</dt>
          <dt class="cont">4. 压缩和液化气体及其容器</dt>
          <dt class="cont">（1）易燃气体：如氢气、甲烷、乙烷、丁烷、天然气、液化石油气、乙烯、丙烯、乙炔、打火机等。</dt>
          <dt class="cont">（2）有毒气体：如一氧化碳、一氧化氮、氯气等。</dt>
          <dt class="cont">（3）易爆或者窒息、助燃气体：如压缩氧气、氮气、氦气、氖气、气雾剂等。</dt>
          <dt class="cont">5. 易燃液体：如汽油、柴油、煤油、桐油、丙酮、乙醚、油漆、生漆、苯、酒精、松香油等。</dt>
          <dt class="cont">6. 易燃固体、自燃物质、遇水易燃物质</dt>
          <dt class="cont">（1）易燃固体：如红磷、硫磺、铝粉、闪光粉、固体酒精、火柴、活性炭等。</dt>
          <dt class="cont">（2）自燃物质：如黄磷、白磷、硝化纤维（含胶片）、钛粉等。</dt>
          <dt class="cont">（3）遇水易燃物质：如金属钠、钾、锂、锌粉、镁粉、碳化钙（电石）、氰化钠、氰化钾等。</dt>
          <dt class="cont">7. 氧化剂和过氧化物：如高锰酸盐、高氯酸盐、氧化氢、过氧化钠、过氧化钾、过氧化铅、氯酸盐、溴酸盐、硝酸盐、双氧水等。</dt>
          <dt class="cont">8. 毒性物质：如砷、砒霜、汞化物、铊化物、氰化物、硒粉、苯酚、汞、剧毒农药等。</dt>
          <dt class="cont">9. 生化制品、传染性、感染性物质：如病菌、炭疽、寄生虫、排泄物、医疗废弃物、尸骨、动物器官、肢体、未经硝制的兽皮、未经药制的兽骨等。</dt>
          <dt class="cont">10. 放射性物质：如铀、钴、镭、钚等。</dt>
          <dt class="cont">11. 腐蚀性物质：如硫酸、硝酸、盐酸、蓄电池、氢氧化钠、氢氧化钾等。</dt>
          <dt class="cont">12. 毒品及吸毒工具、非正当用途麻醉药品和精神药品、非正当用途的易制毒化学品</dt>
          <dt class="cont">（1）毒品、麻醉药品和精神药品：如鸦片（包括罂粟壳、花、苞、叶）、吗啡、海洛因、可卡因、大麻、甲基苯丙胺（冰毒）、氯胺酮、甲卡西酮、苯丙胺、安钠咖等。</dt>
          <dt class="cont">（2）易制毒化学品：如胡椒醛、黄樟素、黄樟油、麻黄素、伪麻黄素、羟亚胺、邻酮、苯乙酸、溴代苯丙酮、醋酸酐、甲苯、丙酮等。</dt>
          <dt class="cont">（3）吸毒工具：如冰壶等。</dt>
          <dt class="cont">13. 非法出版物、印刷品、音像制品等宣传品：如含有反动、煽动民族仇恨、破坏国家统一、破坏社会稳定、宣扬邪教、宗教极端思想、淫秽等内容的图书、刊物、图片、照片、音像制品等。</dt>
          <dt class="cont">14. 间谍专用器材：如暗藏式窃听器材、窃照器材、突发式收发报机、一次性密码本、密写工具、用于获取情报的电子监听和截收器材等。</dt>
          <dt class="cont">15. 非法伪造物品：如伪造或者变造的货币、证件、公章等。</dt>
          <dt class="cont">16. 侵犯知识产权和假冒伪劣物品</dt>
          <dt class="cont ">（1）侵犯知识产权：如侵犯专利权、商标权、著作权的图书、音像制品等；</dt>
          <dt class="cont">（2）假冒伪劣：如假冒伪劣的食品、药品、儿童用品、电子产品、化妆品、纺织品等。</dt>
          <dt class="cont">17. 濒危野生动物及其制品：如象牙、虎骨、犀牛角及其制品等。</dt>
          <dt class="cont">18. 禁止进出境物品：如有碍人畜健康的、来自疫区的以及其他能传播疾病的食品、药品或者其他物品；内容涉及国家秘密的文件、资料及其他物品。</dt>
          <dt class="cont">19. 其他物品：《危险化学品目录》《民用爆炸物品品名表》《易制爆危险化学品名录》《易制毒化学品的分类和品种目录》《中华人民共和国禁止进出境物品表》载明的物品和《人间传染的病原微生物名录》载明的第一、二类病原微生物等，以及法律、行政法规、国务院和国务院有关部门规定禁止寄递的其他物品。</dt>
          <dt class="cont">三、限制寄递物品目录</dt>
          <dt class="cont">应国家邮政局等三部门联合发布的《禁止寄递物品管理规定》要求，以下物品的寄递会有限制：</dt>
          <dt class="cont">1. 活物不能邮递。</dt>
          <dt class="cont">2. 手机不能空运，只能陆运。</dt>
          <dt class="cont">3. 白酒不能超过 56 度，酒精不能邮递。</dt>
          <dt class="cont">4. 每人的单份邮递品，邮寄香烟不能超过两条。</dt>
          <dt class="cont">四、重货物品限制和拒收物品目录</dt>
          <dt class="cont">1. 工艺品类</dt>
          <dt class="cont indent">铁艺物品、铜艺物品、花艺物品、骨雕物品、木雕物品、石雕物品、竹雕物品、炭雕物品、树脂类工艺品（上述物品单票保价在 5000 元以上的拒收）。</dt>
          <dt class="cont">2. 家具机器类</dt>
          <dt class="cont indent">如钢琴、摩托车整件等</dt>
          <dt class="cont">3. 食品类</dt>
          <dt class="cont indent">新鲜的肉、新鲜的水产品、新鲜的蛋类、速冻食品。</dt>
          <dt class="cont">4. 不确定价值类</dt>
          <dt class="cont indent">有效证件、车牌、文件、技术资料、公章、合同、发票、游艇、玉雕物品、象牙雕刻物品、各种土壤样本。</dt>
          <dt class="cont">5. 易碎物品类</dt>
          <dt class="cont indent">纯玻璃制品（灯具、生活器皿类、含玻璃仪器 / 仪表除外）、亚克力板（有机玻璃）、含玻璃的家具（玻璃面积超过家具最大面面积 30%）、大理石类物品。</dt>
          <dt class="cont">6. LED 类</dt>
          <dt class="cont indent">所有非原厂包装的 LED 类电视、LED 类显示器、LED 类显示屏（如果没有原厂包装，则必须为蜂窝纸箱包装）。</dt>
          <dt class="cont">7. 液晶类</dt>
          <dt class="cont indent">所有非原厂包装的液晶类电视、液晶类显示器、液晶类显示屏（如果没有原厂包装，则必须为蜂窝纸箱包装）。</dt>
          <dt class="cont">8. 等离子类</dt>
          <dt class="cont indent">所有非原厂包装的等离子类电视、等离子类显示器、等离子类显示屏（如果没有原厂包装，则必须为蜂窝纸箱包装）。</dt>
          <dt class="cont">9. 特殊类</dt>
          <dt class="cont indent">四氯化碳、二恶英、滴滴涕、氯丹、磁钢及磁铁（仅指包含磁性）、需冷藏或防晒等特殊条件保管的物品。</dt>
          <dt class="cont">10. 体积与重量</dt>
          <dt class="cont indent">&nbsp;&nbsp;体积过大的物品，按体积折算成重量计费。换算标准以提供服务的圆通加盟网点为准。</dt>
          <dt class="cont">11. 异常类</dt>
          <dt class="cont indent">&nbsp;&nbsp;异常类货物的规定以圆通速递官网的规定为准；</dt>
          <dt class="cont">备注：LED 类、液晶类、等离子类原厂包装指：货物出厂时的包装，同时内部缓冲物必须完整。</dt>

        </div>
      </div>
      <div class="y-t-ac y-mt-20">
         <el-checkbox v-model="isChecked">我已阅读，同意以上协议</el-checkbox>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="confirmFn" :disabled="!isChecked">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { insertConfirmRecordApi } from '@/api/waybillPrint/returnPickupPrint';
export default {
  name: "createOrderPrivacy",
  props: ["isShow", "isCheckedPrivacy", "isShowInviteTip"],
  data() {
    return {
      dialogVisible: this.isShow,
      isChecked: this.isCheckedPrivacy || false
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },
  created() {
    this.isChecked = this.isCheckedPrivacy;
  },
  methods: {
    confirmFn() {
      if (!this.isChecked) {
        // this.$message.error('请勾选阅读协议');
        return false;
      }
      insertConfirmRecordApi({pactType: 'returnPickupPrivacy'}).then(res => {
        if (res.status == 200) {
          this.handleClose('refresh');
        }
      }).catch(res => {
        this.$message.error(res.error || '网络异常，请稍候重试');
      })      
    },
    handleClose(refresh) {
      this.dialogVisible = false;
      this.$emit('close', refresh== 'refresh' ? this.isChecked : false);
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.createOrderPrivacy {
  line-height: 24px;
  .title {
    color: #000;
    font-size: 14px;
    font-weight: bold;
    line-height: 28px;
  }
  .indent {
    text-indent: 14px;
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
  padding-top: 0;
}
</style>